import type { ReactNode } from 'react';
import { useState } from 'react';

import { MangopayConsentContext } from './index.ts';

type Props = {
  children: ReactNode;
};

export const MangopayConsentProvider = ({ children }: Props) => {
  const [showMangopayConsent, setShowMangopayConsent] = useState(false);

  return (
    <MangopayConsentContext.Provider
      value={{
        showMangopayConsent,
        setShowMangopayConsent,
      }}
    >
      {children}
    </MangopayConsentContext.Provider>
  );
};
